// extracted by mini-css-extract-plugin
export default {"container":"VerificationSuccess_container__nwvB-","layoutHeader":"VerificationSuccess_layoutHeader__rsfV7"};